/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
export const MILISECONDS_IN_YEAR = 31557600000;
export const EARLIEST_BIRTH_DATE = '1908-01-01';
export const EARLIEST_BEGIN_DATE = '2013-03-01';
export const EARLIEST_EDUCATION_DATE = '1950-01-01';

export const LIST_OF_TABLES: string[] = [
    'User',
    'PersonalInfo',
    'Purpose',
    'WorkExperience',
    'Spouse',
    'FamilyMember',
    'Education',
    'Language',
    'JobOffer',
    'RelativeAbroad',
    'Business',
    // 'LetterOfAcceptance',
];

export const TABLES_TO_PAGES_MAP: { [key: string]: string[] } = {
    'Personal Info': ['User', 'PersonalInfo', 'Spouse', 'FamilyMember'],
    'Visa Purpose': ['Purpose'],
    'Work Experience': ['WorkExperience', 'Spouse'],
    Education: ['Education', 'Spouse'],
    'Language Proficiency': ['Language', 'Spouse'],
    'Job Offer': ['JobOffer'],
    'Relatives Abroad': ['RelativeAbroad'],
    'Business Experience': ['Business'],
    'Letter of acceptance': ['Letter of acceptance'],
};

export const formPathToFormName: { [key: string]: string } = {
    'Business Experience': 'business',
    'Business Ownership': 'business',
    'Spouse/Common Law Partner': 'spouse',
    'Family Members': 'family_member',
    'Additional Details': 'additional_details',
    Education: 'education',
    'Job Offer': 'job_offer',
    'Language Proficiency': 'language',
    'Personal Info': 'personal_info',
    'Visa Purpose': 'purpose',
    'Relatives Abroad': 'relative_abroad',
    'Work Experience': 'work_experience',
};

export const placeholderVisaData: any = [
    {
        country: 'Australia',
        eligible_programs: [
            {
                country: 'Australia',
                immigration_advice:
                    'The Transit Visa (Subclass 771) allows applicant to transit through Australia for a maximum of 72 hours, or enter Australia by air to join the crew of a non-military ship as a Maritime Crew visa (Subclass 988) holder. This visa is free of cost, but applicant must be outside Australia and have a confirmed booking to travel to another country within 72 hours of arriving in Australia. Applicant must also meet health, character, and biometrics requirements, and have adequate health insurance for the duration of applicantr stay. Additionally, if applicant are joining the crew of a non-military ship, applicant must hold a Maritime Crew visa and necessary crew documents. The processing times for this visa range from 1 day to 19 days depending on the percentage of applications, and applicant cannot include family members in applicantr application.',
                program_name: 'Transit Visa - Subclass 771',
                program_type: 'Subclass 771',
                required_score: 0,
                scores: [],
                summary: {
                    max_score: 20,
                    passed: true,
                    required_score: 0,
                    score: 11,
                },
                visa_type: 'Travel',
            },
            {
                country: 'Australia',
                immigration_advice:
                    'The Tourist stream (apply outside Australia) of the Visitor visa (subclass 600) allows individuals to visit Australia as tourists, for a cruise or to see family and friends. The visa can be granted for a period of up to 12 months, with a single or multiple entry. Applicants must have enough funds to support themselves during their stay and cannot work while in Australia. The visa does not allow for business or medical treatment purposes. Applicants must apply for the visa while outside of Australia and are advised to take out adequate health insurance to cover any medical treatment they may need during their stay.',
                program_name: 'Tourist Stream - Subclass 600',
                program_type: 'Subclass 600',
                required_score: 0,
                scores: [
                    {
                        explanation: {
                            text: 'Should apply outside of Australia',
                        },
                        label: 'Visa type',
                        max_score: 0,
                        passed: true,
                        score: 56,
                    },
                    {
                        explanation: {
                            text: 'Applicant must have sufficient liquid assets to sustain him-/herself.',
                        },
                        label: 'Subsistence',
                        max_score: 0,
                        passed: true,
                        score: 0,
                    },
                ],
                summary: {
                    max_score: 0,
                    passed: true,
                    required_score: 0,
                    score: 3,
                },
                visa_type: 'Travel',
            },
            {
                country: 'Australia',
                immigration_advice:
                    "The Subsequent Entry Pathway of the Skilled Regional (Provisional) visa (subclass 489) allows the family members of a subclass 475, 487, 489, 495 or 496 visa holder to stay in Australia while the primary visa is valid. To be eligible, the primary visa holder must have been sponsored by an eligible relative or nominated by an Australian state or territory government to live and work in a specified regional area of Australia. The family members can live, work, and study in the same regional area as the primary visa holder. The visa is temporary and the duration of stay is dependent on the primary visa holder's visa. The visa application costs from AUD 4,240 for the main applicant and there is no standard processing time. If the family members want to stay permanently, they can apply for the Skilled Regional visa (subclass 887) if eligible. Family members who apply for this visa must meet health and character requirements, and pay additional charges for applicants aged 18 years or older with less than functional English.",
                program_name: 'Subsequent Entry Pathway - Subclass 489',
                program_type: 'Subclass 489',
                required_score: 0,
                scores: [
                    {
                        explanation: {
                            text: 'No official requirements.',
                        },
                        label: 'Age',
                        max_score: 10,
                        passed: true,
                        score: 7,
                    },
                    {
                        explanation: {
                            text: 'Should have an IELTS score above 4.5 or equivalent.',
                        },
                        label: 'Language proficiency',
                        max_score: 9,
                        passed: true,
                        score: '7',
                    },
                    {
                        explanation: {
                            text: 'If applicant is in Australia when he/she lodges the application he/she must hold a substantive visa or a subclass 010 Bridging A visa, a subclass 020 Bridging B visa or a subclass 030 Bridging C visa.',
                        },
                        label: 'Visa type',
                        max_score: 0,
                        passed: true,
                        score: 0,
                    },
                ],
                summary: {
                    max_score: 19,
                    passed: true,
                    required_score: 0,
                    score: 11,
                },
                visa_type: 'Work',
            },
        ],
    },
    {
        country: 'Canada',
        eligible_programs: [
            {
                country: 'Australia',
                immigration_advice:
                    'The Transit Visa (Subclass 771) allows applicant to transit through Australia for a maximum of 72 hours, or enter Australia by air to join the crew of a non-military ship as a Maritime Crew visa (Subclass 988) holder. This visa is free of cost, but applicant must be outside Australia and have a confirmed booking to travel to another country within 72 hours of arriving in Australia. Applicant must also meet health, character, and biometrics requirements, and have adequate health insurance for the duration of applicantr stay. Additionally, if applicant are joining the crew of a non-military ship, applicant must hold a Maritime Crew visa and necessary crew documents. The processing times for this visa range from 1 day to 19 days depending on the percentage of applications, and applicant cannot include family members in applicantr application.',
                program_name: 'Transit Visa - Subclass 771',
                program_type: 'Subclass 771',
                required_score: 0,
                scores: [],
                summary: {
                    max_score: 0,
                    passed: true,
                    required_score: 0,
                    score: 96,
                },
                visa_type: 'Travel',
            },
            {
                country: 'Australia',
                immigration_advice:
                    'The Tourist stream (apply outside Australia) of the Visitor visa (subclass 600) allows individuals to visit Australia as tourists, for a cruise or to see family and friends. The visa can be granted for a period of up to 12 months, with a single or multiple entry. Applicants must have enough funds to support themselves during their stay and cannot work while in Australia. The visa does not allow for business or medical treatment purposes. Applicants must apply for the visa while outside of Australia and are advised to take out adequate health insurance to cover any medical treatment they may need during their stay.',
                program_name: 'Tourist Stream - Subclass 600',
                program_type: 'Subclass 600',
                required_score: 0,
                scores: [
                    {
                        explanation: {
                            text: 'Should apply outside of Australia',
                        },
                        label: 'Visa type',
                        max_score: 0,
                        passed: true,
                        score: 0,
                    },
                    {
                        explanation: {
                            text: 'Applicant must have sufficient liquid assets to sustain him-/herself.',
                        },
                        label: 'Subsistence',
                        max_score: 0,
                        passed: true,
                        score: 0,
                    },
                ],
                summary: {
                    max_score: 20,
                    passed: true,
                    required_score: 0,
                    score: 11,
                },
                visa_type: 'Travel',
            },
            {
                country: 'Australia',
                immigration_advice:
                    "The Subsequent Entry Pathway of the Skilled Regional (Provisional) visa (subclass 489) allows the family members of a subclass 475, 487, 489, 495 or 496 visa holder to stay in Australia while the primary visa is valid. To be eligible, the primary visa holder must have been sponsored by an eligible relative or nominated by an Australian state or territory government to live and work in a specified regional area of Australia. The family members can live, work, and study in the same regional area as the primary visa holder. The visa is temporary and the duration of stay is dependent on the primary visa holder's visa. The visa application costs from AUD 4,240 for the main applicant and there is no standard processing time. If the family members want to stay permanently, they can apply for the Skilled Regional visa (subclass 887) if eligible. Family members who apply for this visa must meet health and character requirements, and pay additional charges for applicants aged 18 years or older with less than functional English.",
                program_name: 'Subsequent Entry Pathway - Subclass 489',
                program_type: 'Subclass 489',
                required_score: 0,
                scores: [
                    {
                        explanation: {
                            text: 'No official requirements.',
                        },
                        label: 'Age',
                        max_score: 10,
                        passed: true,
                        score: 7,
                    },
                    {
                        explanation: {
                            text: 'Should have an IELTS score above 4.5 or equivalent.',
                        },
                        label: 'Language proficiency',
                        max_score: 9,
                        passed: true,
                        score: '7',
                    },
                    {
                        explanation: {
                            text: 'If applicant is in Australia when he/she lodges the application he/she must hold a substantive visa or a subclass 010 Bridging A visa, a subclass 020 Bridging B visa or a subclass 030 Bridging C visa.',
                        },
                        label: 'Visa type',
                        max_score: 0,
                        passed: true,
                        score: 0,
                    },
                ],
                summary: {
                    max_score: 19,
                    passed: true,
                    required_score: 0,
                    score: 11,
                },
                visa_type: 'Work',
            },
        ],
    },
];

export const timeZoneCityToCountry: { [key: string]: string } = {
    Andorra: 'Andorra',
    Dubai: 'United Arab Emirates',
    Kabul: 'Afghanistan',
    Tirane: 'Albania',
    Yerevan: 'Armenia',
    Casey: 'Antarctica',
    Davis: 'Antarctica',
    Mawson: 'Antarctica',
    Palmer: 'Antarctica',
    Rothera: 'Antarctica',
    Troll: 'Antarctica',
    Vostok: 'Antarctica',
    Buenos_Aires: 'Argentina',
    Cordoba: 'Argentina',
    Salta: 'Argentina',
    Jujuy: 'Argentina',
    Tucuman: 'Argentina',
    Catamarca: 'Argentina',
    La_Rioja: 'Argentina',
    San_Juan: 'Argentina',
    Mendoza: 'Argentina',
    San_Luis: 'Argentina',
    Rio_Gallegos: 'Argentina',
    Ushuaia: 'Argentina',
    Pago_Pago: 'Samoa (American)',
    Vienna: 'Austria',
    Lord_Howe: 'Australia',
    Macquarie: 'Australia',
    Hobart: 'Australia',
    Melbourne: 'Australia',
    Sydney: 'Australia',
    Broken_Hill: 'Australia',
    Brisbane: 'Australia',
    Lindeman: 'Australia',
    Adelaide: 'Australia',
    Darwin: 'Australia',
    Perth: 'Australia',
    Eucla: 'Australia',
    Baku: 'Azerbaijan',
    Barbados: 'Barbados',
    Dhaka: 'Bangladesh',
    Brussels: 'Belgium',
    Sofia: 'Bulgaria',
    Bermuda: 'Bermuda',
    Brunei: 'Brunei',
    La_Paz: 'Bolivia',
    Noronha: 'Brazil',
    Belem: 'Brazil',
    Fortaleza: 'Brazil',
    Recife: 'Brazil',
    Araguaina: 'Brazil',
    Maceio: 'Brazil',
    Bahia: 'Brazil',
    Sao_Paulo: 'Brazil',
    Campo_Grande: 'Brazil',
    Cuiaba: 'Brazil',
    Santarem: 'Brazil',
    Porto_Velho: 'Brazil',
    Boa_Vista: 'Brazil',
    Manaus: 'Brazil',
    Eirunepe: 'Brazil',
    Rio_Branco: 'Brazil',
    Thimphu: 'Bhutan',
    Minsk: 'Belarus',
    Belize: 'Belize',
    St_Johns: 'Canada',
    Halifax: 'Canada',
    Glace_Bay: 'Canada',
    Moncton: 'Canada',
    Goose_Bay: 'Canada',
    Toronto: 'Canada',
    Nipigon: 'Canada',
    Thunder_Bay: 'Canada',
    Iqaluit: 'Canada',
    Pangnirtung: 'Canada',
    Winnipeg: 'Canada',
    Rainy_River: 'Canada',
    Resolute: 'Canada',
    Rankin_Inlet: 'Canada',
    Regina: 'Canada',
    Swift_Current: 'Canada',
    Edmonton: 'Canada',
    Cambridge_Bay: 'Canada',
    Yellowknife: 'Canada',
    Inuvik: 'Canada',
    Dawson_Creek: 'Canada',
    Fort_Nelson: 'Canada',
    Whitehorse: 'Canada',
    Dawson: 'Canada',
    Vancouver: 'Canada',
    Cocos: 'Cocos (Keeling) Islands',
    Zurich: 'Switzerland',
    Abidjan: "Côte d'Ivoire",
    Rarotonga: 'Cook Islands',
    Santiago: 'Chile',
    Punta_Arenas: 'Chile',
    Easter: 'Chile',
    Shanghai: 'China',
    Urumqi: 'China',
    Bogota: 'Colombia',
    Costa_Rica: 'Costa Rica',
    Havana: 'Cuba',
    Cape_Verde: 'Cape Verde',
    Christmas: 'Christmas Island',
    Nicosia: 'Cyprus',
    Famagusta: 'Cyprus',
    Prague: 'Czech Republic',
    Berlin: 'Germany',
    Copenhagen: 'Denmark',
    Santo_Domingo: 'Dominican Republic',
    Algiers: 'Algeria',
    Guayaquil: 'Ecuador',
    Galapagos: 'Ecuador',
    Tallinn: 'Estonia',
    Cairo: 'Egypt',
    El_Aaiun: 'Western Sahara',
    Madrid: 'Spain',
    Ceuta: 'Spain',
    Canary: 'Spain',
    Helsinki: 'Finland',
    Fiji: 'Fiji',
    Stanley: 'Falkland Islands',
    Chuuk: 'Micronesia',
    Pohnpei: 'Micronesia',
    Kosrae: 'Micronesia',
    Faroe: 'Faroe Islands',
    Paris: 'France',
    London: 'Britain (UK)',
    Tbilisi: 'Georgia',
    Cayenne: 'French Guiana',
    Gibraltar: 'Gibraltar',
    Nuuk: 'Greenland',
    Danmarkshavn: 'Greenland',
    Scoresbysund: 'Greenland',
    Thule: 'Greenland',
    Athens: 'Greece',
    South_Georgia: 'South Georgia & the South Sandwich Islands',
    Guatemala: 'Guatemala',
    Guam: 'Guam',
    Bissau: 'Guinea-Bissau',
    Guyana: 'Guyana',
    Hong_Kong: 'Hong Kong',
    Tegucigalpa: 'Honduras',
    'Port-au-Prince': 'Haiti',
    Budapest: 'Hungary',
    Jakarta: 'Indonesia',
    Pontianak: 'Indonesia',
    Makassar: 'Indonesia',
    Jayapura: 'Indonesia',
    Dublin: 'Ireland',
    Jerusalem: 'Israel',
    Kolkata: 'India',
    Calcutta: 'India',
    Chagos: 'British Indian Ocean Territory',
    Baghdad: 'Iraq',
    Tehran: 'Iran',
    Reykjavik: 'Iceland',
    Rome: 'Italy',
    Jamaica: 'Jamaica',
    Amman: 'Jordan',
    Tokyo: 'Japan',
    Nairobi: 'Kenya',
    Bishkek: 'Kyrgyzstan',
    Tarawa: 'Kiribati',
    Kanton: 'Kiribati',
    Kiritimati: 'Kiribati',
    Pyongyang: 'Korea (North)',
    Seoul: 'Korea (South)',
    Almaty: 'Kazakhstan',
    Qyzylorda: 'Kazakhstan',
    Qostanay: 'Kazakhstan',
    Aqtobe: 'Kazakhstan',
    Aqtau: 'Kazakhstan',
    Atyrau: 'Kazakhstan',
    Oral: 'Kazakhstan',
    Beirut: 'Lebanon',
    Colombo: 'Sri Lanka',
    Monrovia: 'Liberia',
    Vilnius: 'Lithuania',
    Luxembourg: 'Luxembourg',
    Riga: 'Latvia',
    Tripoli: 'Libya',
    Casablanca: 'Morocco',
    Monaco: 'Monaco',
    Chisinau: 'Moldova',
    Majuro: 'Marshall Islands',
    Kwajalein: 'Marshall Islands',
    Yangon: 'Myanmar (Burma)',
    Ulaanbaatar: 'Mongolia',
    Hovd: 'Mongolia',
    Choibalsan: 'Mongolia',
    Macau: 'Macau',
    Martinique: 'Martinique',
    Malta: 'Malta',
    Mauritius: 'Mauritius',
    Maldives: 'Maldives',
    Mexico_City: 'Mexico',
    Cancun: 'Mexico',
    Merida: 'Mexico',
    Monterrey: 'Mexico',
    Matamoros: 'Mexico',
    Mazatlan: 'Mexico',
    Chihuahua: 'Mexico',
    Ojinaga: 'Mexico',
    Hermosillo: 'Mexico',
    Tijuana: 'Mexico',
    Bahia_Banderas: 'Mexico',
    Kuala_Lumpur: 'Malaysia',
    Kuching: 'Malaysia',
    Maputo: 'Mozambique',
    Windhoek: 'Namibia',
    Noumea: 'New Caledonia',
    Norfolk: 'Norfolk Island',
    Lagos: 'Nigeria',
    Managua: 'Nicaragua',
    Amsterdam: 'Netherlands',
    Oslo: 'Norway',
    Kathmandu: 'Nepal',
    Nauru: 'Nauru',
    Niue: 'Niue',
    Auckland: 'New Zealand',
    Chatham: 'New Zealand',
    Panama: 'Panama',
    Lima: 'Peru',
    Tahiti: 'French Polynesia',
    Marquesas: 'French Polynesia',
    Gambier: 'French Polynesia',
    Port_Moresby: 'Papua New Guinea',
    Bougainville: 'Papua New Guinea',
    Manila: 'Philippines',
    Karachi: 'Pakistan',
    Warsaw: 'Poland',
    Miquelon: 'St Pierre & Miquelon',
    Pitcairn: 'Pitcairn',
    Puerto_Rico: 'Puerto Rico',
    Gaza: 'Palestine',
    Hebron: 'Palestine',
    Lisbon: 'Portugal',
    Madeira: 'Portugal',
    Azores: 'Portugal',
    Palau: 'Palau',
    Asuncion: 'Paraguay',
    Qatar: 'Qatar',
    Reunion: 'Réunion',
    Bucharest: 'Romania',
    Belgrade: 'Serbia',
    Kaliningrad: 'Russia',
    Moscow: 'Russia',
    Simferopol: 'Russia',
    Kirov: 'Russia',
    Volgograd: 'Russia',
    Astrakhan: 'Russia',
    Saratov: 'Russia',
    Ulyanovsk: 'Russia',
    Samara: 'Russia',
    Yekaterinburg: 'Russia',
    Omsk: 'Russia',
    Novosibirsk: 'Russia',
    Barnaul: 'Russia',
    Tomsk: 'Russia',
    Novokuznetsk: 'Russia',
    Krasnoyarsk: 'Russia',
    Irkutsk: 'Russia',
    Chita: 'Russia',
    Yakutsk: 'Russia',
    Khandyga: 'Russia',
    Vladivostok: 'Russia',
    'Ust-Nera': 'Russia',
    Magadan: 'Russia',
    Sakhalin: 'Russia',
    Srednekolymsk: 'Russia',
    Kamchatka: 'Russia',
    Anadyr: 'Russia',
    Riyadh: 'Saudi Arabia',
    Guadalcanal: 'Solomon Islands',
    Mahe: 'Seychelles',
    Khartoum: 'Sudan',
    Stockholm: 'Sweden',
    Singapore: 'Singapore',
    Paramaribo: 'Suriname',
    Juba: 'South Sudan',
    Sao_Tome: 'Sao Tome & Principe',
    El_Salvador: 'El Salvador',
    Damascus: 'Syria',
    Grand_Turk: 'Turks & Caicos Is',
    Ndjamena: 'Chad',
    Kerguelen: 'French Southern & Antarctic Lands',
    Bangkok: 'Thailand',
    Dushanbe: 'Tajikistan',
    Fakaofo: 'Tokelau',
    Dili: 'East Timor',
    Ashgabat: 'Turkmenistan',
    Tunis: 'Tunisia',
    Tongatapu: 'Tonga',
    Istanbul: 'Turkey',
    Funafuti: 'Tuvalu',
    Taipei: 'Taiwan',
    Kiev: 'Ukraine',
    Uzhgorod: 'Ukraine',
    Zaporozhye: 'Ukraine',
    Wake: 'US minor outlying islands',
    New_York: 'United States',
    Detroit: 'United States',
    Louisville: 'United States',
    Monticello: 'United States',
    Indianapolis: 'United States',
    Vincennes: 'United States',
    Winamac: 'United States',
    Marengo: 'United States',
    Petersburg: 'United States',
    Vevay: 'United States',
    Chicago: 'United States',
    Tell_City: 'United States',
    Knox: 'United States',
    Menominee: 'United States',
    Center: 'United States',
    New_Salem: 'United States',
    Beulah: 'United States',
    Denver: 'United States',
    Boise: 'United States',
    Phoenix: 'United States',
    Los_Angeles: 'United States',
    Anchorage: 'United States',
    Juneau: 'United States',
    Sitka: 'United States',
    Metlakatla: 'United States',
    Yakutat: 'United States',
    Nome: 'United States',
    Adak: 'United States',
    Honolulu: 'United States',
    Montevideo: 'Uruguay',
    Samarkand: 'Uzbekistan',
    Tashkent: 'Uzbekistan',
    Caracas: 'Venezuela',
    Ho_Chi_Minh: 'Vietnam',
    Efate: 'Vanuatu',
    Wallis: 'Wallis & Futuna',
    Apia: 'Samoa (western)',
    Johannesburg: 'South Africa',
    Antigua: 'Antigua & Barbuda',
    Anguilla: 'Anguilla',
    Luanda: 'Angola',
    McMurdo: 'Antarctica',
    DumontDUrville: 'Antarctica',
    Syowa: 'Antarctica',
    Aruba: 'Aruba',
    Mariehamn: 'Åland Islands',
    Sarajevo: 'Bosnia & Herzegovina',
    Ouagadougou: 'Burkina Faso',
    Bahrain: 'Bahrain',
    Bujumbura: 'Burundi',
    'Porto-Novo': 'Benin',
    St_Barthelemy: 'St Barthelemy',
    Kralendijk: 'Caribbean NL',
    Nassau: 'Bahamas',
    Gaborone: 'Botswana',
    'Blanc-Sablon': 'Canada',
    Atikokan: 'Canada',
    Creston: 'Canada',
    Kinshasa: 'Congo (Dem. Rep.)',
    Lubumbashi: 'Congo (Dem. Rep.)',
    Bangui: 'Central African Rep.',
    Brazzaville: 'Congo (Rep.)',
    Douala: 'Cameroon',
    Curacao: 'Curaçao',
    Busingen: 'Germany',
    Djibouti: 'Djibouti',
    Dominica: 'Dominica',
    Asmara: 'Eritrea',
    Addis_Ababa: 'Ethiopia',
    Libreville: 'Gabon',
    Grenada: 'Grenada',
    Guernsey: 'Guernsey',
    Accra: 'Ghana',
    Banjul: 'Gambia',
    Conakry: 'Guinea',
    Guadeloupe: 'Guadeloupe',
    Malabo: 'Equatorial Guinea',
    Zagreb: 'Croatia',
    Isle_of_Man: 'Isle of Man',
    Jersey: 'Jersey',
    Phnom_Penh: 'Cambodia',
    Comoro: 'Comoros',
    St_Kitts: 'St Kitts & Nevis',
    Kuwait: 'Kuwait',
    Cayman: 'Cayman Islands',
    Vientiane: 'Laos',
    St_Lucia: 'St Lucia',
    Vaduz: 'Liechtenstein',
    Maseru: 'Lesotho',
    Podgorica: 'Montenegro',
    Marigot: 'St Martin (French)',
    Antananarivo: 'Madagascar',
    Skopje: 'North Macedonia',
    Bamako: 'Mali',
    Saipan: 'Northern Mariana Islands',
    Nouakchott: 'Mauritania',
    Montserrat: 'Montserrat',
    Blantyre: 'Malawi',
    Niamey: 'Niger',
    Muscat: 'Oman',
    Kigali: 'Rwanda',
    St_Helena: 'St Helena',
    Ljubljana: 'Slovenia',
    Longyearbyen: 'Svalbard & Jan Mayen',
    Bratislava: 'Slovakia',
    Freetown: 'Sierra Leone',
    San_Marino: 'San Marino',
    Dakar: 'Senegal',
    Mogadishu: 'Somalia',
    Lower_Princes: 'St Maarten (Dutch)',
    Mbabane: 'Eswatini (Swaziland)',
    Lome: 'Togo',
    Port_of_Spain: 'Trinidad & Tobago',
    Dar_es_Salaam: 'Tanzania',
    Kampala: 'Uganda',
    Midway: 'US minor outlying islands',
    Vatican: 'Vatican City',
    St_Vincent: 'St Vincent',
    Tortola: 'Virgin Islands (UK)',
    St_Thomas: 'Virgin Islands (US)',
    Aden: 'Yemen',
    Mayotte: 'Mayotte',
    Lusaka: 'Zambia',
    Harare: 'Zimbabwe',
};

export const formNameMapper: { [key: string]: string } = {
    personal_info: 'Personal Info',
    purpose: 'Visa Purpose',
    language: 'Language Proficiency',
    education: 'Education',
    work_experience: 'Work Experience',
    job_offer: 'Job Offer',
    relative_abroad: 'Relatives Abroad',
    business: 'Business Ownership',
};

export const General_path = (hasSpouse?: string, hasFamily?: string) => {
    return [
        'Personal Info',
        //'Visa Purpose',
        'Additional Details',
        `${hasSpouse === 'Yes' ? 'Spouse/Common Law Partner' : ''}`,
        //`${hasFamily === 'Yes' ? 'Family Members' : ''}`,
        'Family Members',
        'Language Proficiency',
        'Education',
        'Work Experience',
        'Job Offer',
        'Relatives Abroad',
        'Business Ownership',
    ];
};
export const General_path_percentage = (hasSpouse?: string, hasFamily?: string) => {
    if (hasSpouse === 'Yes') {
        //&& hasFamily === 'Yes'
        return ['0%', '20%', '35%', '40%', '50%', '60%', '70%', '80%', '90%', '100%'];
    } else if (hasSpouse && hasSpouse !== 'No') {
        return ['0%', '23.5%', '35%', '41%', '53%', '64%', '76%', '88%', '100%'];
        // } else if (hasFamily && hasFamily !== 'No') {
        //     return ['0%', '23.5%', '35%', '41%', '53%', '64%', '76%', '88%', '100%'];
    } else {
        return ['0', '25%', '37.5%', '50%', '62.5%', '75%', '87.5%', '100%'];
    }
};

export const Travel_path = (hasSpouse?: string, hasFamily?: string) => {
    return [
        'Personal Info',
        // 'Visa Purpose',
        'Additional Details',
        `${hasSpouse === 'Yes' ? 'Spouse/Common Law Partner' : ''}`,
        // `${hasFamily === 'Yes' ? 'Family Members' : ''}`,
        'Family Members',
    ];
};

export const Travel_path_percentage = (hasSpouse?: string, hasFamily?: string) => {
    if (hasSpouse === 'Yes') {
        //&& hasFamily === 'Yes'
        return ['0%', '50%', '75%', '87.5%', '100%'];
    } else if (hasSpouse && hasSpouse !== 'No') {
        return ['0%', '50%', '86%', '100%'];
        // } else if (hasFamily && hasFamily !== 'No') {
        //     return ['0%', '50%', '86%', '100%'];
    } else {
        return ['0%', '50%', '100%'];
    }
};

export const Work_path = (hasSpouse?: string, hasFamily?: string) => {
    return [
        'Personal Info',
        // 'Visa Purpose',
        'Additional Details',
        `${hasSpouse === 'Yes' ? 'Spouse/Common Law Partner' : ''}`,
        // `${hasFamily === 'Yes' ? 'Family Members' : ''}`,
        'Family Members',
        'Language Proficiency',
        'Education',
        'Work Experience',
        'Job Offer',
        'Relatives Abroad',
        'Business Ownership',
    ];
};

export const Work_path_percentage = (hasSpouse?: string, hasFamily?: string) => {
    if (hasSpouse === 'Yes') {
        //&& hasFamily === 'Yes'
        return ['0%', '20%', '35%', '40%', '50%', '60%', '70%', '80%', '90%', '100%'];
    } else if (hasSpouse && hasSpouse !== 'No') {
        return ['0%', '23.5%', '35%', '41%', '53%', '64%', '76%', '88%', '100%'];
        // } else if (hasFamily && hasFamily !== 'No') {
        //     return ['0%', '23.5%', '35%', '41%', '53%', '64%', '76%', '88%', '100%'];
    } else {
        return ['0', '25%', '37.5%', '50%', '62.5%', '75%', '87.5%', '100%'];
    }
};

export const Business_path = (hasSpouse?: string, hasFamily?: string) => {
    return [
        'Personal Info',
        // 'Visa Purpose',
        'Additional Details',
        `${hasSpouse === 'Yes' ? 'Spouse/Common Law Partner' : ''}`,
        // `${hasFamily === 'Yes' ? 'Family Members' : ''}`,
        'Family Members',
        'Language Proficiency',
        'Education',
        'Work Experience',
        'Business Ownership',
    ];
};

export const Business_path_percentage = (hasSpouse?: string, hasFamily?: string) => {
    if (hasSpouse === 'Yes') {
        //&& hasFamily === 'Yes'
        return ['0%', '25%', '37.5%', '44%', '50%', '62.5%', '75%', '87.5%', '100%'];
    } else if (hasSpouse && hasSpouse !== 'No') {
        return ['0%', '25%', '40%', '47%', '60%', '73%', '86%', '100%'];
        // } else if (hasFamily && hasFamily !== 'No') {
        //     return ['0%', '25%', '40%', '47%', '60%', '73%', '86%', '100%'];
    } else {
        return ['0', '25%', '43%', '57%', '71%', '86%', '100%'];
    }
};

export const Study_path = (hasSpouse?: string, hasFamily?: string) => {
    return [
        'Personal Info',
        // 'Visa Purpose',
        'Additional Details',
        `${hasSpouse === 'Yes' ? 'Spouse/Common Law Partner' : ''}`,
        // `${hasFamily === 'Yes' ? 'Family Members' : ''}`,
        'Family Members',
        'Language Proficiency',
        'Education',
        'Work Experience',
    ];
};
export const Study_path_percentage = (hasSpouse?: string, hasFamily?: string) => {
    if (hasSpouse === 'Yes') {
        // && hasFamily === 'Yes'
        return ['0%', '29%', '42%', '50%', '57%', '71%', '86%', '100%'];
    } else if (hasSpouse && hasSpouse !== 'No') {
        return ['0%', '29%', '46%', '54%', '69%', '85%', '100%'];
        // } else if (hasFamily && hasFamily !== 'No') {
        //     return ['0%', '29%', '46%', '54%', '69%', '85%', '100%'];
    } else {
        return ['0', '29%', '50%', '67%', '83%', '100%'];
    }
};

export enum VisaPurposes {
    BUSINESS = 'BUSINESS',
    GENERAL = 'GENERAL',
    TRAVEL = 'TRAVEL',
    STUDY = 'STUDY',
    WORK = 'WORK',
    NOPREFERENCE = 'ALL',
}

export enum VisaPurposeServerValues {
    BUSINESS = 'BUSINESS',
    TRAVEL = 'TRAVEL',
    STUDY = 'STUDY',
    WORK = 'WORK',
    ALL = 'GENERAL',
}

export enum TicketStatus {
    PENDING = 'PENDING',
    IN_REVIEW = 'IN_REVIEW',
    RESOLVED = 'RESOLVED',
    CLOSED = 'CLOSED',
}

export enum TicketUrgency {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
    CRITICAL = 'CRITICAL',
}

export const TICKET_URGENCY_CONFIG: Record<string, { label: string; color: string; bg: string }> = {
    [TicketUrgency.LOW]: { label: 'Low', color: '#065F46', bg: '#D1FAE5' },
    [TicketUrgency.MEDIUM]: { label: 'Medium', color: '#1E40AF', bg: '#DBEAFE' },
    [TicketUrgency.HIGH]: { label: 'High', color: '#5B21B6', bg: '#EDE9FE' },
};

export const TICKET_STATUS_CARD_STYLES: Record<
    string,
    {
        label: string;
        color: string;
        bg: string;
        border: string;
    }
> = {
    [TicketStatus.PENDING]: {
        label: 'Pending',
        color: '#92400E',
        bg: '#FEF3C7',
        border: '#F59E0B',
    },
    [TicketStatus.IN_REVIEW]: {
        label: 'In Review',
        color: '#1E40AF',
        bg: '#DBEAFE',
        border: '#3B82F6',
    },
    [TicketStatus.RESOLVED]: {
        label: 'Resolved',
        color: '#065F46',
        bg: '#D1FAE5',
        border: '#10B981',
    },
    [TicketStatus.CLOSED]: { label: 'Closed', color: '#374151', bg: '#F3F4F6', border: '#9CA3AF' },
};
